import { useGlobalData } from '@@app/hooks';

export const withGlobalData = (Component) => {
  return function WithGlobalData (props) {
    const {
      allowedPostalCodes,
      jobs,
      professionalSituations,
      regimeObligatoire,
      socioProfessionalCategories,
      activities,
      insurances,
      familySituations,
      organismCodes,
      phoneIndicatives,
      productCode,
      activeUserInformation,
      viewMode,
      loadingGlobalData,
      usersInformation,
      getProject
    } = useGlobalData();

    if (loadingGlobalData) {
      return null;
    }

    return (
      <Component
        {...props}
        allowedPostalCodes={allowedPostalCodes}
        jobs={jobs}
        socioProfessionalCategories={socioProfessionalCategories}
        professionalSituations={professionalSituations}
        activities={activities}
        regimeObligatoire={regimeObligatoire}
        insurances={insurances}
        familySituations={familySituations}
        organismCodes={organismCodes}
        phoneIndicatives={phoneIndicatives}
        productCode={productCode}
        activeUserInformation={activeUserInformation}
        viewMode={viewMode}
        usersInformation={usersInformation}
        getProject={getProject}
      />
    );
  };
};

export default withGlobalData;
